import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AntTypography from 'antd/lib/typography';
import Input from 'antd/lib/input';

import { IconRobot, IconSend } from '@tabler/icons-react';

import styles from './message-card.module.css';

const MAX_MESSAGE_LENGTH = 1000;

const { TextArea } = Input;
const { Paragraph } = AntTypography;

export default function MessageCard({ customMessage, setCustomMessage, generateAIMessage, generatingMessage, selectedRegion, selectedSites, handleSubmitConfirm, loading }) {
    return (
        <Box className={styles.messageSection}>
            <div className={styles.sectionHeader}>
              <div className={styles.headerLeft}>
                <Typography variant="h6">Message</Typography>
                <Typography variant="caption" color="textSecondary">
                  {customMessage.length}/{MAX_MESSAGE_LENGTH} characters
                </Typography>
              </div>
              <Button
                size="small"
                onClick={generateAIMessage}
                startIcon={<IconRobot size={16} />}
                className={`${styles.generateButton} ${generatingMessage ? styles.loading : ''}`}
                disabled={generatingMessage || !selectedRegion}
                loading={generatingMessage}
              >
                Generate with AI
              </Button>
            </div>
            <TextArea
              placeholder="Enter your storm strategy message..."
              value={customMessage}
              onChange={e => {
                if (e.target.value.length <= MAX_MESSAGE_LENGTH) {
                  setCustomMessage(e.target.value);
                }
              }}
              rows={4}
              className={styles.messageInput}
              showCount
              maxLength={MAX_MESSAGE_LENGTH}
            />
            <Paragraph type="secondary" className={styles.messageGuideline}>
              Include important details such as expected weather conditions, 
              required preparations, and specific instructions for site management.
            </Paragraph>
            <div className={styles.messageActions}>
              <Button
                type="primary"
                size="large"
                onClick={handleSubmitConfirm}
                disabled={!selectedRegion || selectedSites.length === 0 || !customMessage.trim() || loading.sending}
                loading={loading.sending}
                endIcon={<IconSend size={20} />}
                className={styles.sendButton}
              >
                Send Storm Strategy
              </Button>
            </div>
        </Box>
    )
}